import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

const API_URL = process.env.REACT_APP_BACKEND_URL || "";

const VerifyEmailPage = () => {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setStatus("error");
      setMessage("Lien de vérification manquant.");
      return;
    }
    (async () => {
      try {
        const { data } = await axios.post(
          `${API_URL}/api/auth/verify-email`,
          { token },
          { withCredentials: true }
        );
        setStatus("success");
        setMessage(data.message || "Email vérifié avec succès");
      } catch (error) {
        setStatus("error");
        setMessage(
          error.response?.data?.detail ||
            "Lien invalide ou expiré. Vous pouvez en demander un nouveau depuis votre tableau de bord."
        );
      }
    })();
  }, [params]);

  return (
    <div className="min-h-screen bg-slate-50 font-['DM_Sans'] flex flex-col">
      <header className="bg-white border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center h-16">
            <Link to="/" className="flex items-center gap-2">
              <img src="/logo-hostprotect.png" alt="HostProtect" className="h-9 w-auto" />
            </Link>
          </div>
        </div>
      </header>
      <main className="flex-1 flex items-center justify-center py-12 px-4">
        <div className="bg-white border border-slate-200 rounded-2xl p-8 shadow-lg w-full max-w-md text-center">
          {status === "loading" && (
            <>
              <Loader2 className="w-12 h-12 text-[#00B8E4] animate-spin mx-auto mb-4" />
              <h1 className="text-xl font-bold text-[#19294C] font-['Outfit']">
                Vérification en cours…
              </h1>
            </>
          )}
          {status === "success" && (
            <>
              <CheckCircle2 className="w-14 h-14 text-green-500 mx-auto mb-4" />
              <h1 className="text-2xl font-bold text-[#19294C] font-['Outfit']">
                Email vérifié
              </h1>
              <p className="mt-3 text-slate-600">{message}</p>
              <Link
                to="/dashboard"
                className="mt-6 inline-block bg-[#00B8E4] hover:bg-[#00a5ce] text-white py-3 px-6 rounded-full font-semibold"
              >
                Aller au tableau de bord
              </Link>
            </>
          )}
          {status === "error" && (
            <>
              <XCircle className="w-14 h-14 text-red-500 mx-auto mb-4" />
              <h1 className="text-2xl font-bold text-[#19294C] font-['Outfit']">
                Vérification impossible
              </h1>
              <p className="mt-3 text-slate-600">{message}</p>
              <Link
                to="/connexion"
                className="mt-6 inline-block bg-[#00B8E4] hover:bg-[#00a5ce] text-white py-3 px-6 rounded-full font-semibold"
              >
                Se connecter
              </Link>
            </>
          )}
        </div>
      </main>
    </div>
  );
};

export default VerifyEmailPage;
